module.exports = __webpack_public_path__ + "img/lyn-profile-image.87c520d4.webp";